import React from 'react';
import { Flex, Grid, Heading, Text, Card, Badge, Box } from '@magicpatterns/cubed';
export function ComplianceSection() {
  return <Flex direction="column" gap="5" data-id="element-1">
      <Box data-id="element-2">
        <Heading size="5" mb="2" data-id="element-3">
          Compliance & Certifications
        </Heading>
        <Text size="3" color="gray" data-id="element-4">
          Our security practices are independently verified and certified.
        </Text>
      </Box>

      <Grid columns={{
      initial: '1',
      md: '3'
    }} gap="4" data-id="element-5">
        <Card variant="surface" size="2" className="transition-all duration-200 hover:shadow-md hover:-translate-y-0.5" data-id="element-6">
          <Flex direction="column" gap="4" align="start" data-id="element-7">
            <img src="https://www.magicpatterns.com/soc2-type-2.svg" alt="SOC 2 Type II" style={{
            height: 48
          }} data-id="element-8" />
            <Box data-id="element-9">
              <Heading size="3" mb="1" data-id="element-10">
                SOC 2 Type II
              </Heading>
              <Text size="2" color="gray" mb="3" as="p" data-id="element-11">
                Independently audited for security, availability, and
                confidentiality.
              </Text>
              <Badge variant="soft" color="jade" data-id="element-12">
                Compliant
              </Badge>
            </Box>
          </Flex>
        </Card>

        <Card variant="surface" size="2" className="transition-all duration-200 hover:shadow-md hover:-translate-y-0.5" data-id="element-13">
          <Flex direction="column" gap="4" align="start" data-id="element-14">
            <img src="https://www.magicpatterns.com/soc2-type-1.svg" alt="SOC 2 Type I" style={{
            height: 48
          }} data-id="element-15" />
            <Box data-id="element-16">
              <Heading size="3" mb="1" data-id="element-17">
                SOC 2 Type I
              </Heading>
              <Text size="2" color="gray" mb="3" as="p" data-id="element-18">
                Verified design and implementation of security controls.
              </Text>
              <Badge variant="soft" color="jade" data-id="element-19">
                Compliant
              </Badge>
            </Box>
          </Flex>
        </Card>

        <Card variant="surface" size="2" className="transition-all duration-200 hover:shadow-md hover:-translate-y-0.5" data-id="element-20">
          <Flex direction="column" gap="4" align="start" data-id="element-21">
            <img src="https://www.magicpatterns.com/iso.svg" alt="ISO 27001" style={{
            height: 48
          }} data-id="element-22" />
            <Box data-id="element-23">
              <Heading size="3" mb="1" data-id="element-24">
                ISO 27001
              </Heading>
              <Text size="2" color="gray" mb="3" as="p" data-id="element-25">
                International standard for information security management.
              </Text>
              <Badge variant="soft" color="jade" data-id="element-26">
                Compliant
              </Badge>
            </Box>
          </Flex>
        </Card>
      </Grid>
    </Flex>;
}